import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, translate, ValidatedField, ValidatedForm, ValidatedBlobField } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity, updateEntity, createEntity, reset } from './part.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const PartUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const partEntity = useAppSelector(state => state.part.entity);
  const loading = useAppSelector(state => state.part.loading);
  const updating = useAppSelector(state => state.part.updating);
  const updateSuccess = useAppSelector(state => state.part.updateSuccess);

  const handleClose = () => {
    props.history.goBack();
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...partEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...partEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.part.home.createOrEditLabel" data-cy="PartCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.part.home.createOrEditLabel">Create or edit a Part</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              <ValidatedField label={translate('fleetSenseApp.part.name')} id="part-name" name="name" data-cy="name" type="text" required />
              <ValidatedField label={translate('fleetSenseApp.part.code')} id="part-code" name="code" data-cy="code" type="text" />
              <ValidatedField label={translate('fleetSenseApp.part.km')} id="part-cycleKm" name="cycleKm" data-cy="cycleKm" type="number" min={0} />
              <ValidatedField label={translate('fleetSenseApp.part.period')} id="part-cycleDate" name="cycleDate" data-cy="cycleDate" type="number" min={0} />
              {/* <ValidatedField label={translate('fleetSenseApp.part.hour')} id="part-cycleHour" name="cycleHour" data-cy="cycleHour" type="number" /> */}
              <ValidatedBlobField label={translate('fleetSenseApp.part.image')} id="part-image" name="image" data-cy="image" isImage accept="image/*" />
              {/* <ValidatedField
                label={translate('fleetSenseApp.part.objectKey')}
                id="part-objectKey"
                name="objectKey"
                data-cy="objectKey"
                type="text"
              /> */}
              <ValidatedField
                label={translate('fleetSenseApp.part.description')}
                id="part-description"
                name="description"
                data-cy="description"
                type="textarea"
              />
              {/* <ValidatedField
                id="part-company"
                name="companyId"
                data-cy="company"
                label={translate('fleetSenseApp.part.company')}
                type="select"
              >
                <option value="" key="0" />
                {companies
                  ? companies.map(otherEntity => (
                    <option value={otherEntity.id} key={otherEntity.id}>
                      {otherEntity.name}
                    </option>
                  ))
                  : null}
              </ValidatedField> */}
              <Button id="cancel-save" data-cy="entityCreateCancelButton" replace color="info" onClick={() => props.history.goBack()}>
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PartUpdate;
